import {
  VENDOR_OVERVIEW_BILLING_FETCHING,
  VENDOR_OVERVIEW_BILLING_FAILED,
  VENDOR_OVERVIEW_BILLING_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case VENDOR_OVERVIEW_BILLING_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case VENDOR_OVERVIEW_BILLING_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case VENDOR_OVERVIEW_BILLING_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
